exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/angular/DineroAgil/src/app/admin/admin-dashboard2/admin-dashboard2.component.css
// module id = ../../../../../src/app/admin/admin-dashboard2/admin-dashboard2.component.css
// module chunks = main